import { INITIATE_STATE_FROM_STORAGE } from './actionTypes';

const initiateStateFromStorage = stateFromStorage => ({
    type: INITIATE_STATE_FROM_STORAGE,
    payload: stateFromStorage,
});

export default initiateStateFromStorage;
